module.exports = __webpack_public_path__ + "img/9788994210766.ef96b13f.jpg";